// @ts-nocheck
import React from 'react'
import { browserHistory } from 'react-router'
import { CardActions, CardTitle } from 'material-ui/Card'
import ListIcon from 'material-ui/svg-icons/action/list'
import FlatButton from 'material-ui/FlatButton'

import api from '../../../api'
import OrderSummary from './summary'
import Reservations from './reservations'
import Payments from './payments'
import Invoice from './invoice'

const Spacer = () => <div style={{ paddingTop: '20px' }} />

const styles = {
  cardActions: {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
    padding: '14px 0',
    marginRight: -8
  }
}

class ManageOrder extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false,
      lastUpdatedAt: null
    }
  }

  componentWillMount () {
    this.loadOrder()
      .then(() => {
        this.setState({ isLoaded: true })
      })
  }

  componentWillReceiveProps () {
    this.loadOrder()
      .then(() => {
        this.setState({ isLoaded: true })
      })
  }

  loadOrder () {
    return api.get(`admin/orders/${this.props.params.orderId}?with_deleted=true`)
      .then(res => res.json())
      .then(order => {
        this.setState({ order })
        return order
      })
  }

  handleOrderChanged = (order = null) => {
    if (order === null) {
      this.loadOrder()
    } else {
      this.setState({ order })
    }
  }

  handlePaymentsChanged = (lastUpdatedAt) => {
    this.setState({ lastUpdatedAt })
  }

  render () {
    if (!this.state.isLoaded) {
      return null
    }

    const { order } = this.state

    return (
      <div>
        <CardActions style={styles.cardActions}>
          <FlatButton
            onClick={() => {
              browserHistory.push('/ecommerce/orders')
            }}
            icon={<ListIcon />}
            title='Back to list'
          />
        </CardActions>

        <CardTitle title={`Order #${order.id}`} style={{ paddingLeft: 0 }} />

        <Spacer />
        <OrderSummary order={order} onOrderChanged={this.handleOrderChanged} />
        <Spacer />
        <Reservations order={order} onOrderChanged={this.handleOrderChanged} />
        <Spacer />
        <Payments order={order} onOrderChanged={this.handleOrderChanged} handlePaymentsChanged={this.handlePaymentsChanged} lastUpdatedAt={this.state.lastUpdatedAt} />
        <Spacer />
        <Payments order={order} onOrderChanged={this.handleOrderChanged} handlePaymentsChanged={this.handlePaymentsChanged} lastUpdatedAt={this.state.lastUpdatedAt} isVoid />
        <Spacer />
        <Invoice order={order} onOrderChanged={this.handleOrderChanged} />
      </div>
    )
  }
}

// @ts-ignore
ManageOrder.propTypes = {
  params: React.PropTypes.shape({
    orderId: React.PropTypes.string.isRequired
  }).isRequired
}

export default ManageOrder
